import { createResource } from '../utils/resource'
import axios from 'axios'

const baseResource = createResource('user', {})

const userStore = {
    ...baseResource,

    state: {
        ...baseResource.state,

        trainerItems: [],
        trainerLoading: false,
        trainerError: null,
    },

    mutations: {
        ...baseResource.mutations,

        GET_TRAINER_LIST_REQUEST(state: any) {
            state.trainerLoading = true
            state.trainerError = null
        },

        GET_TRAINER_LIST_SUCCESS(state: any, payload: any) {
            state.trainerItems = payload
            state.trainerLoading = false
        },

        GET_TRAINER_LIST_FAILURE(state: any, error: any) {
            state.trainerError = error
            state.trainerLoading = false
        },

        RESET_TRAINER_LIST(state: any) {
            state.trainerItems = []
            state.trainerLoading = false
            state.trainerError = null
        },
    },

    actions: {
        ...baseResource.actions,

        async getTrainerList({ commit }: any, params: any) {
            commit('GET_TRAINER_LIST_REQUEST')
            try {
                const response = await axios.get('/api/user', {
                    params: {
                        ...params,
                        search: 'trainer'
                    }
                })
                commit('GET_TRAINER_LIST_SUCCESS', response.data.items || response.data)
                return response.data
            } catch (error) {
                commit('GET_TRAINER_LIST_FAILURE', error)
                throw error
            }
        },

        resetTrainerList({ commit }: any) {
            commit('RESET_TRAINER_LIST')
        },
    },

    getters: {
        ...baseResource.getters,

        getTrainerList: (state: any) => state.trainerItems,
        getTrainerLoading: (state: any) => state.trainerLoading,
        getTrainerError: (state: any) => state.trainerError,
    }
}

export default userStore
